import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function ClockDisplay() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-card/95 backdrop-blur-sm border border-border rounded-lg px-4 py-2.5 shadow-lg">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-muted-foreground" />
        <div className="text-right">
          <p className="text-sm font-mono font-bold text-foreground leading-none">
            {currentTime.toLocaleTimeString('en-US', { hour12: false })}
          </p>
          <p className="text-[9px] text-muted-foreground mt-0.5">
            {currentTime.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
}
